import { render, staticRenderFns } from "./Submenu5.vue?vue&type=template&id=683a27af&scoped=true&"
import script from "./Submenu5.vue?vue&type=script&lang=js&"
export * from "./Submenu5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683a27af",
  null
  
)

export default component.exports